export function getFromPayload(key, token)
{
    if (typeof token === 'undefined') {
        token = window.authorisation.getToken();
    }

    return JSON.parse(atob(token.split('.')[1].replace(/\s+/g, '').replace(/\-/g, '+').replace(/\_/g, '/')))[key]; // eslint-disable-line
}

/**
 * Show's these elements
 *
 * @param name
 */
export function show(name)
{
    document.querySelectorAll(name).forEach((elm) => {
        elm.style.display = '';
    });
}

/**
 * Hide's these elements
 *
 * @param name
 */
export function hide(name)
{
    console.log('helpers.hide', name);
    document.querySelectorAll(name).forEach((elm) => {
        elm.style.display = 'none';
    });
}

/**
 * Get Cookie
 * @param cname
 * @returns {null|string}
 */
export function getCookie(cname)
{
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }

    return null;
}

/**
 * Get CSRF and Session Token
 * @returns {Promise<unknown>}
 */
export function getCsrfAndSessionToken () {
    return new Promise((resolve) => {
        fetch(window.loginEndpoint + '/csrf', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        })
            .then(response => {
                console.log(response);
                resolve(getCookie('XSRF-TOKEN'));
            });
    });
}
